export default {
  name: 'ms-US English (Latin)',
  lang: ['en-US'],
  normal: [
    'q w e r t y u i o p ',
    'a s d f g h j k l',
    '{shift}  z x c v b n m {bksp}',
    '{numbers} {space} . -',
  ],
  shift: [
    'Q W E R T Y U I O P { } |',
    'A S D F G H J K L {enter}',
    '{shift} Z X C V B N M {bksp}',
    '{numbers} {space} . -',
  ],
  numbers: [
    '1 2 3 4 5 6 7 8 9 0',
    '~ ! @ # $ % ^ & * ( ) _ +',
    '| , . / : \u0022 \u005c {bksp}',
    '{numbers} {space} . -',
  ],
};
